module.exports = __webpack_public_path__ + "img/icons-beer.f5ed7b33.svg";